// src/components/MainLayout.jsx
import React from 'react';
import { Box, AppBar, Toolbar, Typography, IconButton, Avatar, Menu, MenuItem } from '@mui/material';
import MenuIcon from '@mui/icons-material/Menu';
import AccountCircleIcon from '@mui/icons-material/AccountCircle';
import LogoutIcon from '@mui/icons-material/Logout';
import Sidebar from './Sidebar';
import AlertBadge from './AlertBadge';
import NotificationCenter from './NotificationCenter';
import { useNavigate } from 'react-router-dom';

const drawerWidth = 240;

const MainLayout = ({ children }) => {
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [mobileOpen, setMobileOpen] = React.useState(false);
  const navigate = useNavigate();

  const handleAvatarClick = (e) => {
    setAnchorEl(e.currentTarget);
  };
  const handleAvatarClose = () => {
    setAnchorEl(null);
  };
  
  const handleProfile = () => {
    navigate('/admin/profile');
    setAnchorEl(null);
  };
  
  const handleLogout = () => {
    // Xóa token/localStorage, chuyển về /login
    localStorage.removeItem('token');
    navigate('/login');
  };

  const handleDrawerToggle = () => {
    setMobileOpen(!mobileOpen);
  };

  return (
    <Box sx={{ display: 'flex' }}>
      <AppBar
        position="fixed"
        sx={{ zIndex: (theme) => theme.zIndex.drawer + 1 }}
      >
        <Toolbar>
          <IconButton
            color="inherit"
            edge="start"
            sx={{ mr: 2, display: { sm: 'none' } }}
            onClick={handleDrawerToggle}
          >
            <MenuIcon />
          </IconButton>
          <Typography variant="h6" component="div" sx={{ flexGrow: 1 }}>
            Admin Dashboard
          </Typography>
          
          {/* Notifications & Alerts */}
          <NotificationCenter />
          <AlertBadge />
          
          <IconButton color="inherit" onClick={handleAvatarClick}>
            <Avatar alt="User" src="" />
          </IconButton>
          <Menu
            anchorEl={anchorEl}
            open={Boolean(anchorEl)}
            onClose={handleAvatarClose}
          >
            <MenuItem onClick={handleProfile}>
              <AccountCircleIcon sx={{ mr: 1 }} />
              Profile của tôi
            </MenuItem>
            <MenuItem onClick={handleLogout}>
              <LogoutIcon sx={{ mr: 1 }} />
              Logout
            </MenuItem>
          </Menu>
        </Toolbar>
      </AppBar>
      <Sidebar mobileOpen={mobileOpen} onDrawerToggle={handleDrawerToggle} />
      <Box
        component="main"
        sx={{
          flexGrow: 1,
          bgcolor: 'background.default',
          p: 3,
          marginTop: '64px', // chiều cao AppBar
          ml: { sm: `${drawerWidth}px` }, // Thêm margin-left cho desktop
        }}
      >
        {children}
      </Box>
    </Box>
  );
};

export default MainLayout;
